<template>
  <div class="page acoperis-expert">
    <div class="container-fluid">
      <div class="row">
        <div class="col col-lg-7">
          <div class="roof-companies">
            <div class="inner-content">
              <div class="companies">
                <router-link to="/ruukki" class="company-website">
                  <img src="/src/assets/img/ruukki-logo.png" alt="Ruuki - Building your tomorrow" />
                  <span class="company-website__link">Ruuki - Building your tomorrow</span>
                </router-link>
                <router-link to="/gerard" class="company-website">
                  <img
                    src="/src/assets/img/gerard-logo.png"
                    alt="Gerard - Soluții premium pentru acoperișuri"
                  />
                  <span class="company-website__link">Gerard - Soluții premium pentru acoperișuri</span>
                </router-link>
                <router-link to="/novatik" class="company-website">
                  <img
                    src="/src/assets/img/novatik-logo.png"
                    alt="Novatik - Soluții premium pentru acoperișuri"
                  />
                  <span class="company-website__link">Novatik - Soluții premium pentru acoperișuri</span>
                </router-link>
                <a
                  href="https://distributietransilvania.ro/"
                  target="_blank"
                  class="company-website"
                >
                  <img
                    src="/src/assets/img/wetterbest-logo.png"
                    alt="Wetterbest - Distribuție Transilvania"
                  />
                  <span class="company-website__link">Wetterbest - Distribuție Transilvania</span>
                </a>
                <a
                  href="/INDEX_PRODUSE_ACOPERIS_EXPERT.pdf"
                  class="pdf-link p-4 d-flex align-items-center"
                  target="_blank"
                >
                  <font-awesome-icon icon="file-pdf" class="fas mr-1"></font-awesome-icon>Index Produse Acoperiș Expert
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-5">
          <div class="windows-companies">
            <div class="inner-content">
              <div class="companies">
                <router-link to="/dakea" class="company-website">
                  <img src="/src/assets/img/dakea-logo.svg" alt="Dakea - ferestre și luminatoare" />
                  <span class="company-website__link">Dakea - ferestre și luminatoare</span>
                </router-link>
                <router-link to="/fakro" class="company-website">
                  <img src="/src/assets/img/fakro-logo.gif" alt="Fakro - ferestre masnardă" />
                  <span class="company-website__link">Fakro - ferestre mansardă</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../../assets/css/_variables.scss";
.pdf-link {
  margin: 10px;
  background-color: rgba($primary-color, 0.9);
  border-radius: $round-corners;
  color: $white;
  &:hover {
    background-color: $primary-color;
    color: $white;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/pages/AcoperisExpert.vue